<template>
  <div
    class="input-group color-picker"
    :class="{
      'color-picker--disabled': disabled,
      'color-picker--merged': merged,
      'color-picker--top': position === 'top',
      'color-picker--bottom': position === 'bottom',
    }"
    ref="colorpicker"
  >
    <span class="input-group-addon color-picker-container">
      <span
        class="current-color"
        :style="'background-color: ' + colorValue"
        @click="togglePicker()"
      />
      <chrome-picker
        v-if="displayPicker"
        :formats="['hex']"
        :value="colors"
        :disable-alpha="disableAlpha"
        :disable-fields="disableFields"
        @input="updateFromPicker"
      />
    </span>
    <a-input
      v-if="withClipboard"
      class="form-control pk_input with-clipboard"
      size="large"
      v-model="colorValue"
      :disabled="disabled"
      @focus="showPicker()"
      @input="updateFromInput"
    />
    <a-input
      v-else
      class="form-control pk_input"
      size="large"
      v-model="colorValue"
      :disabled="disabled"
      @focus="showPicker()"
      @input="updateFromInput"
    />
    <span class="color-picker-clipboard-container" v-if="withClipboard">
      <span class="color-picker-clipboard">
        <a-tooltip title="Copy to clipboard" placement="bottom">
          <a href="javascript:;">
            <a-icon
              type="copy"
              class="font-size-18"
              @click="clipboardHandle(colorValue)"
            />
          </a>
        </a-tooltip>
      </span>
    </span>
  </div>
</template>

<script>
import { Chrome } from 'vue-color'

export default {
  name: 'inputColorPicker',
  components: {
    'chrome-picker': Chrome,
  },
  props: {
    color: String,
    withClipboard: {
      type: Boolean,
      default: false,
    },
    disableAlpha: {
      type: Boolean,
      default: false,
    },
    disableFields: {
      type: Boolean,
      default: false,
    },
    merged: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String, // 'top', 'bottom'
      default: 'bottom',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      colors: {
        hex: '#000000',
      },
      colorValue: '',
      displayPicker: false,
    }
  },
  mounted() {
    this.setColor(this.color || '#000000')
  },
  methods: {
    setColor(color) {
      this.updateColors(color)
      this.colorValue = color
    },
    updateColors(color) {
      if (color.slice(0, 1) === '#') {
        this.colors = {
          hex: color,
        }
      } else if (color.slice(0, 4) === 'rgba') {
        const rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',')
        const hex =
          '#' +
          (
            (1 << 24) +
            (parseInt(rgba[0]) << 16) +
            (parseInt(rgba[1]) << 8) +
            parseInt(rgba[2])
          )
            .toString(16)
            .slice(1)
        this.colors = {
          hex: hex,
          a: rgba[3],
        }
      }
    },
    showPicker() {
      document.addEventListener('click', this.documentClick)
      this.displayPicker = true
    },
    hidePicker() {
      document.removeEventListener('click', this.documentClick)
      this.displayPicker = false
    },
    togglePicker() {
      this.displayPicker ? this.hidePicker() : this.showPicker()
    },
    updateFromInput() {
      this.updateColors(this.colorValue)
    },
    updateFromPicker(color) {
      this.colors = color
      if (color.rgba.a === 1) {
        this.colorValue = color.hex
      } else {
        this.colorValue =
          'rgba(' +
          color.rgba.r +
          ', ' +
          color.rgba.g +
          ', ' +
          color.rgba.b +
          ', ' +
          color.rgba.a +
          ')'
      }
    },
    documentClick(e) {
      const el = this.$refs.colorpicker
      const target = e.target
      if (el !== target && !el?.contains(target)) {
        this.hidePicker()
      }
    },
    // clipboardMessage(field, v) {
    //   this.$notification.success({
    //     message: field + ' copied to clipboard',
    //     description: v,
    //   })
    // },
    clipboardHandle(text) {
      this.$clipboard(text)
      // this.clipboardMessage('Promocode', text.slice(0, 6) + '...')
    },
  },
  watch: {
    color(val) {
      if (val) {
        this.setColor(val)
      }
    },
    colorValue(val) {
      if (val) {
        this.updateColors(val)
        this.$emit('input', val)
        // document.body.style.background = val;
      }
    },
  },
}
</script>
<style lang="scss">
.vc-chrome {
  position: absolute;
  top: 40px;
  right: 0;
  z-index: 9;
}
.current-color {
  display: inline-block;
  width: 20px;
  height: 20px;
  background-color: #000;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  margin-top: calc(50% - 10px);
  margin-left: calc(50% - 10px);
  cursor: pointer;
}
.color-picker-container,
.color-picker-clipboard-container {
  display: inline-block !important;
  border: 1px solid #d9d9d9 !important;
  border-right-style: none !important;
  background: transparent;
  border-radius: 2px 0px 0px 2px;
  height: 40px;
  width: 40px;
  transition: all 0.3s;
}
.color-picker-clipboard-container {
  width: 28px;
  border-radius: 0px 2px 2px 0px;
  border-right-style: solid !important;
  border-left-style: none !important;
  .color-picker-clipboard {
    margin: 2px 0 0 2px;
  }
}
.pk_input.ant-input {
  display: inline-block !important;
  width: calc(100% - 40px - 28px) !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  color: #262626;
  border-color: #d9d9d9;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
.pk_input.ant-input::selection,
.pk_input.ant-input:hover,
.pk_input.ant-input:focus {
  border-color: #d9d9d9 !important;
}
.pk_input.with-clipboard.ant-input {
  border-right-style: none !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.color-picker--merged {
  .color-picker-container {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    width: auto;
    height: auto;
    padding-left: 7px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .current-color {
    width: 16px;
    height: 16px;
    display: block;
    margin: 0;
    border-radius: 4px;
  }

  .pk_input.ant-input {
    border-left: none;
    padding-left: 6px;
  }
}

.color-picker--disabled {
  .color-picker-container {
    cursor: not-allowed;
    background-color: #e4e9f0;
  }

  .current-color {
    pointer-events: none;
  }
}
</style>
<style scoped>
.color-picker--top >>> .vc-chrome {
  top: initial;
  bottom: 40px;
  right: 0;
}

.color-picker >>> .vc-chrome-toggle-btn {
  display: none;
}

.color-picker >>> .vc-input__input {
  border: 1px solid #d9d9d9 !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  height: 24px;
}

.color-picker >>> .vc-input__label {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
</style>
